// 活動輪播元件
'use client';
import Link from 'next/link';
import Image from 'next/image';
import '../../styles/swipers.scss';

export const EventsSwiperSlide = ({banner, link}) => {
    return(
        <>
            { link 
                ?(
                    <Link
                        href={link}
                        className="group"
                        target={banner?.link ? '_blank' : ''}
                        rel="noreferrer noopener"
                    >
                        <div className="w-full h-full img-box rounded-[2px] overflow-hidden after:content-none">
                            <Image
                                loading="eager"
                                priority={true}
                                className="hover-img"
                                width={600}
                                height={300}
                                src={banner?.image || '/images/news/default_related.svg'}
                                alt="banner"
                            />
                        </div>
                    </Link>
                )
                :(
                    <div className="group w-full h-full">
                        <div className="w-full h-full img-box rounded-[2px] overflow-hidden after:content-none">
                            <Image
                                loading="eager"
                                priority={true}
                                className="hover-img"
                                width={600}
                                height={300}
                                src={banner?.image || '/images/news/default_related.svg'}
                                alt="banner"
                            />
                        </div>
                    </div>
                )
            }
        </>
        
    )
}